module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "13zu9heh",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
